import React from 'react';
import { siteContent } from '../data/mock';

const MechanismSection = () => {
  const { mechanism } = siteContent;

  return (
    <section className="mechanism-section section-padding" data-testid="mechanism-section" data-reveal="fade">
      <div className="container">
        <div className="mechanism-header">
          <h2 className="mechanism-title" data-testid="mechanism-title">{mechanism.title}</h2>
          <p className="mechanism-subtitle">{mechanism.subtitle}</p>
        </div>

        <div className="mechanism-intro-block">
          <p className="mechanism-introduction">{mechanism.introduction}</p>
          <p className="mechanism-thesis">{mechanism.mainThesis}</p>
          <p className="mechanism-core">{mechanism.coreStatement}</p>
        </div>

        <div className="mechanism-failures">
          <h3 className="mechanism-failures-title">{mechanism.whyCurrentSolutionsFail.title}</h3>
          <div className="mechanism-failures-grid">
            {mechanism.whyCurrentSolutionsFail.points.map((point, index) => (
              <div key={index} className="mechanism-failure-card" data-testid={`mechanism-failure-${index}`}>
                <h4 className="failure-card-title">{point.title}</h4>
                <p className="failure-card-description">{point.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mechanism-works">
          <h3 className="mechanism-works-title">{mechanism.whyThisWorks.title}</h3>
          <p className="mechanism-works-description">{mechanism.whyThisWorks.description}</p>
          <blockquote className="mechanism-key-point" data-testid="mechanism-key-point">
            {mechanism.whyThisWorks.keyPoint}
          </blockquote>
        </div>

        <div className="mechanism-evidence">
          {mechanism.evidence.map((item, index) => (
            <p key={index} className="mechanism-evidence-item">{item}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MechanismSection;
